import * as ACTION_TYPE from 'action-creators/user/controlPin/constants';

const initialState = {
  controlPinStatus: {
    initial: false,
    payload: {},
    loading: false,
    error: false,
  },
};

const controlPinStatusReducer = (
  state = initialState.controlPinStatus,
  action,
) => {
  switch (action.type) {
    case ACTION_TYPE.CONTROL_PIN_BEGIN: {
      return {
        ...state,
        payload: {},
        loading: true,
        error: false,
      };
    }
    case ACTION_TYPE.CONTROL_PIN_STATUS_SUCCESS: {
      const { payload: initial } = action;
      return {
        payload: {},
        initial,
        loading: false,
        error: false,
      };
    }
    case ACTION_TYPE.CONTROL_PIN_ACTIVE_SUCCESS:
    case ACTION_TYPE.CONTROL_PIN_CHANGE_SUCCESS:
    case ACTION_TYPE.CONTROL_PIN_CHECK_SUCCESS:
    case ACTION_TYPE.CONTROL_PIN_MODIFY_SUCCESS:
    case ACTION_TYPE.CONTROL_PIN_REMIND_SUCCESS:
    case ACTION_TYPE.CONTROL_PIN_SET_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        payload,
        loading: false,
        error: false,
      };
    }
    case ACTION_TYPE.CONTROL_PIN_ERROR: {
      return {
        ...state,
        payload: {},
        loading: false,
        error: {
          ...action.payload,
        },
      };
    }
    default:
      return state;
  }
};

export default controlPinStatusReducer;
